import { createContext, useState } from 'react';

export const ShapeTabContext = createContext<any>({});

export const ShapeTabContextProvider = (props: any) => {
    const [collapsed, setCollapsed] = useState(false);

    const updateCollapsedState = (isCollapsed: boolean) => {
        setCollapsed(isCollapsed);
    };

    return (
        <ShapeTabContext.Provider
            value={{
                collapsed,
                updateCollapsedState,
            }}
        >
            {props.children}
        </ShapeTabContext.Provider>
    );
};
